import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { OFFER_TEMPLATE_SETTINGS_FRAGMENT } from 'graphql/fragments/offer-template-settings';
import { SNK_PRICE_DESCRIPTOR_FRAGMENT } from 'graphql/fragments/snk-price-descriptor';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';
import { Query as RootQuery } from 'graphql/models/generated';

export const OFFER_VERSIONS_QUERY = gql`
query revisionsForOffer($expressions: ExpressionsInput!) {
  quotes {
    groupedRevisions(
      expressions: $expressions
    ) {
      items {
        title
        documentId
        revisions {
          title
          dealerOfferTitle: customProperty(key: "DealerOfferTitle") { stringValue }
          manufacturerOfferTitle: customProperty(key: "ManufacturerOfferTitle") { stringValue }
          revision
          locked
          status
          createdByType # TODO: DIT-713: might need to re-add alias
          snkModifier {
            username
            accountType
            profile {
              firstName
              lastName
            }
          }
          branch {
            offerTemplateSettings {
              ...OfferTemplateSettingsFragment
            }
          }
          createdDate
          modifiedDate
          pricing {
            totalBuyPrice { ...SnkPriceDescriptorFragment }
            totalSellPrice { ...SnkPriceDescriptorFragment }
            totalNetBuyPrice { ...SnkPriceDescriptorFragment }
          }
          ...QuotePricingStateFragment
        }
      }
    }
  }
}
${OFFER_TEMPLATE_SETTINGS_FRAGMENT}
${SNK_PRICE_DESCRIPTOR_FRAGMENT}
${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class OfferVersionsQuery extends Query<RootQuery> {
  document = OFFER_VERSIONS_QUERY;
}
